import React, { Component } from 'react';

class SearchBar extends Component {
    componentDidMount() {
		document.getElementById('search').onkeydown = function(e){
            if(e.keyCode === 13){       
                //window.location = "https://duckduckgo.com/?q=" + document.getElementById('search').value;
                window.location = "https://www.google.com/search?q=" + document.getElementById('search').value;
            }	
        }
	}
	render() {
		return (
			<div className="search-bar-frame">
				<input type="search" name="search" id="search" autoComplete="off"></input>
			</div>
		);
	}
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/Components/SearchBar/SearchBar.js